import { z } from 'zod';

export const GetLinkCouponServiceRequestDtoSchema = z.object({
  couponNo: z.number().int(),
});

export type GetLinkCouponServiceRequest = z.infer<typeof GetLinkCouponServiceRequestDtoSchema>;

export const GetLinkCouponServiceResponseDtoSchema = z.object({
  shortLink: z.string(),
});

export type GetLinkCouponServiceResponse = z.infer<typeof GetLinkCouponServiceResponseDtoSchema>;
